import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import Moment from 'moment'
import {connect} from 'react-redux'

import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'
import {formatNumber} from "../../../utils/jsUtils"

import AwardInfo from "../common/dialogs/AwardInfo"
import {
  DETAIL_TITLE_NUMBER_SIZE,
  DETAIL_TITLE_NUMBER_WEIGHT,
  GenericDetailTitle
} from "../common/dialogs/GenericDetailTitle"
import {DIALOGS} from "../common/common"

import {Text} from '@amzn/stencil-react-components/text'
import {Col, Row, Hr, Spacer, View} from '@amzn/stencil-react-components/layout'
import {Button, ButtonVariant} from '@amzn/stencil-react-components/dist/submodules/button'
import {Flyout, FlyoutContent} from '@amzn/stencil-react-components/flyout'

export class ReviewAwardDialog extends Component {

  createVestScheduleRow = (vest, index) => {
    return (
      <View>
        <Row>
          <Text>{Moment(vest.vest_date).format('ll')}</Text>
          <Spacer flex={1}/>
          <Text fontWeight="bold">
            {formatNumber(this.props.locale, vest.vest_shares)} RSUs
          </Text>
        </Row>
      </View>
    );
  }

  renderVestSchedule = (award, t) => {
    const vestSchedule = employeeService.extractVestSchedule(award);

    return (
      <Col gridGap="S200">
        <GenericDetailTitle
          title={t('ReviewAwardDialog.VestSchedule')}
        />
        {vestSchedule.map((vest, index) => {
          return this.createVestScheduleRow(vest, index)
        })}
      </Col>
    )
  }

  renderTotal = (award, t) => {
    return (
      <Row alignItems="center">
        <GenericDetailTitle
          title={t('ReviewAwardDialog.Total')}
        />
        <Spacer flex={1}/>
        <Text fontSize={DETAIL_TITLE_NUMBER_SIZE} fontWeight={DETAIL_TITLE_NUMBER_WEIGHT}>
          {formatNumber(this.props.locale, award.shares_awarded)} RSUs
        </Text>
      </Row>
    )
  }

  render() {
    const {t, employee, award} = this.props;

    if (!award) {
      return null;
    }

    const canAcceptAward = employeeService.hasRole(employee.roles, UserRoles.ACCEPT_AWARD);

    return (
      <Flyout dataTestId="ReviewAwardDialog" isOpen={this.props.visible} close={this.props.onCloseDialog}>
        <FlyoutContent
          titleText={t('ReviewAwardDialog.Title', {award_type_name: award.amazon_award_name})}
          closeButtonAltText="Close Button For Review Award Dialog"
          onCloseButtonClick={this.props.onCloseDialog}
          buttons={[
            <Button onClick={this.props.onButtonPress} disabled={!canAcceptAward} variant={ButtonVariant.Primary}>
              {t('ReviewAwardDialog.ViewDocumentation')}
            </Button>
          ]}
        >
          <Col gridGap="S400">
            <AwardInfo
              award={award}
              dialogName={DIALOGS.ReviewAwardDialog}
              locale={this.props.locale}
            />
            <Hr/>
            {this.renderVestSchedule(award, t)}
            <Hr/>
            {this.renderTotal(award, t)}
          </Col>
        </FlyoutContent>
      </Flyout>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  locale: state.employee.language
});

export default connect(mapState)(withTranslation('translationsV2')(ReviewAwardDialog));

